"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Vehicle = exports.ModelYear = exports.Data = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var Vehicle = _propTypes["default"].shape({
  vehicleName: _propTypes["default"].string.isRequired,
  vehicleCode: _propTypes["default"].string,
  imagePath: _propTypes["default"].string.isRequired,
  imageAltText: _propTypes["default"].string,
  // TODO: BE should not null(SEO - isRequired)
  MSRP: _propTypes["default"].string.isRequired,
  price: _propTypes["default"].shape({
    value: _propTypes["default"].number,
    displayValue: _propTypes["default"].string,
    zeroMessage: _propTypes["default"].string
  }),
  isActive: _propTypes["default"].bool
});
exports.Vehicle = Vehicle;
var ModelYear = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  year: _propTypes["default"].string.isRequired
});
exports.ModelYear = ModelYear;
var Data = _propTypes["default"].shape({
  locale: _propTypes["default"].string.isRequired,
  zipCodeHeadingText: _propTypes["default"].string.isRequired,
  zipCodeLabel: _propTypes["default"].string.isRequired,
  modelYearLabel: _propTypes["default"].string.isRequired,
  modelYear: _propTypes["default"].arrayOf(ModelYear),
  vehicles: _propTypes["default"].arrayOf(Vehicle),
  disclaimerLabel: _propTypes["default"].string,
  disclaimerList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    disclaimerNumber: _propTypes["default"].string,
    disclaimerContent: _propTypes["default"].string,
    associated: _propTypes["default"].string
  })),
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
exports.Data = Data;